export const checkFeature = (feature) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.has(feature);
};
